module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "MediaGridItemTestimonials"
  }, [(_vm.data.title) ? _c('h3', {
    staticClass: "MediaGridItemTestimonials-title t-heading-sm"
  }, [_vm._v("\n    " + _vm._s(_vm.data.title) + "\n  ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.data.items), function(item) {
    return _c('blockquote', {
      staticClass: "MediaGridItemTestimonials-testimonial"
    }, [(item.quote) ? _c('markdown', {
      staticClass: "MediaGridItemTestimonials-quote",
      attrs: {
        "content": item.quote
      }
    }) : _vm._e(), _vm._v(" "), (item.citation) ? _c('cite', [_c('p', {
      staticClass: "MediaGridItemTestimonials-citation"
    }, [_vm._v("\n        " + _vm._s(item.citation) + "\n      ")])]) : _vm._e()], 1)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24e82ea2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MediaGridItemTestimonials.vue
// module id = 749
// module chunks = 1474